module.exports = __webpack_public_path__ + "img/t4-i13.bb7c9466.jpg";